import script from "./AppManufacturer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManufacturer.vue?vue&type=script&setup=true&lang=js"

import "./AppManufacturer.vue?vue&type=style&index=0&id=57bde69f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bde69f"]])

export default __exports__